/**
 * @note This must be preceded by a line with `// @ts-expect-error`.
 *
 * @see https://www.typescriptlang.org/docs/handbook/release-notes/typescript-3-9.html#-ts-expect-error-comments
 */
export const nonDate = 'test'

/**
 * Actual `Date` object, but an invalid date.
 */
export const invalidDate = new Date(nonDate)

/**
 * This is not safe for tests that validate how a date is actually handled,
 * because it’s completely uncontrolled and will have unpredictable behavior.
 * It’s useful for validating high-level behavior--for example, if a function
 * calls `ensureValidDate` or `ensureValidLocale` from `@opallabs/lambda`.
 *
 * @note Don’t rely on the specific value; it may change at any time.
 */
export const unsafeGenericDate = new Date()

/**
 * A date that is:
 * * in the relatively-recent past, so DST, time zones, etc. are static
 * * not in DST
 * * not a leap year
 * * in a year with 52 ISO weeks (years like 2020 and 2025 have 53 ISO weeks)
 *
 * @see https://en.wikipedia.org/wiki/ISO_week_date#Weeks_per_year
 *
 * @note If this value changes you’ll need to change your tests.
 */
export const safeDate = new Date(2005, 1, 1)
/**
 * A safe date in the same month as `safeDate`. Useful for testing formatting.
 *
 * @note If this value changes you’ll need to change your tests.
 */
export const safeDateSameMonth = new Date(2005, 1, 2)
/**
 * A safe date in the same year as `safeDate`, but a different month. Useful for
 * testing formatting.
 *
 * @note If this value changes you’ll need to change your tests.
 */
export const safeDateSameYear = new Date(2005, 7, 1)
/**
 * A safe date in a different year than `safeDate`. Useful for testing
 * formatting.
 *
 * @note If this value changes you’ll need to change your tests.
 */
export const safeDateDifferentYear = new Date(2006, 1, 1)
